// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — app.styled.classic.js, новая — app.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './app.styled.classic';
import * as cp from './app.styled.cp';

export const BenefitPlace = isCp ? cp.BenefitPlace : classic.BenefitPlace;
export const BottomContent = isCp ? cp.BottomContent : classic.BottomContent;
export const Info = isCp ? cp.Info : classic.Info;
export const InfoHeader = isCp ? cp.InfoHeader : classic.InfoHeader;
export const StyledControlPanel = isCp ? cp.StyledControlPanel : classic.StyledControlPanel;
export const TopContentWrapper = isCp ? cp.TopContentWrapper : classic.TopContentWrapper;
